// Reportes de palabras (lo que el alumno manda desde la ronda: «Error: …» o «Pregunta: …») en nuestro
// Firestore en vez del servidor de Inowu. Se encienden junto con el avance propio (ver AvancePropio.ts).
//
//   vocabularioReportes/{id}  { num, word, language, comment, date, checked (0/1), word_data_id, user_id, creado }
//
// Los 368 reportes viejos de Inowu se cargan con scripts/vocabulario/cargar-reportes.js (conservan su id numérico).

import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { db } from "initFirebase";
import { palabraPropia } from "./VocabularioPropio";

const REPORTES = "vocabularioReportes";

export async function agregarReportePropio(fecha: any, seminario: any, wordDataId: number, comentario: string, alumno: any) {
	const palabra = await palabraPropia(Number(wordDataId)).catch(() => null);
	const fechaIso = fecha instanceof Date ? fecha.toISOString() : new Date(fecha).toISOString();
	const nuevo = await addDoc(collection(db, REPORTES), {
		num: Number(seminario),
		word: palabra?.palabra ?? "",
		language: palabra?.idioma ?? "",
		comment: comentario,
		date: fechaIso,
		checked: 0,
		word_data_id: Number(wordDataId),
		user_id: String(alumno ?? ""),
		creado: Timestamp.now(),
	});
	return { message: "ok", id: nuevo.id };
}

/** Misma forma que `GET reports` de Inowu: { reports: [ … ] }, del más viejo al más nuevo. */
export async function reportesPropios() {
	const snap = await getDocs(collection(db, REPORTES));
	const reports = snap.docs.map((d) => ({ ...d.data(), id: d.id } as Record<string, any>));
	reports.sort((a, b) => String(a.date).localeCompare(String(b.date)));
	return { reports };
}

export async function marcarReportePropio(checked: number | boolean, id: string | number) {
	await updateDoc(doc(db, REPORTES, String(id)), { checked: checked ? 1 : 0 });
	return { status: 200 };
}

export async function borrarReportePropio(id: string | number) {
	await deleteDoc(doc(db, REPORTES, String(id)));
	return { status: 200 };
}

// ---------------------------------------------------------------------------------------------
// Marcas de palabras con nota (antes words/bookmark/…): el alumno marca una palabra para que el equipo
// la revise. vocabularioMarcas/{id de palabra} { nota, fecha }. Las 61 marcas viejas se cargan con
// scripts/vocabulario/cargar-reportes.js (del respaldo del 31 oct, que sí traía bookmark/notes).
// ---------------------------------------------------------------------------------------------

const MARCAS = "vocabularioMarcas";

export async function marcarPalabraPropia(wordId: number, nota: string) {
	await setDoc(doc(db, MARCAS, String(wordId)), { nota: nota ?? "", fecha: Timestamp.now() });
	return { status: 200 };
}

export async function desmarcarPalabraPropia(wordId: number) {
	await deleteDoc(doc(db, MARCAS, String(wordId)));
	return { status: 200 };
}

/** Misma forma que `GET words/bookmark/{id}`: { bookmark: [ … ] } (vacío si no está marcada). */
export async function marcaDePalabraPropia(wordId: number) {
	const snap = await getDoc(doc(db, MARCAS, String(wordId)));
	return { bookmark: snap.exists() ? [{ id: wordId, notes: snap.data()?.nota ?? "" }] : [] };
}
